export default {
      id: "ic_trash_disabled-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#ic_trash_disabled-usage",
      toString: function () {
        return this.url;
      }
    }